export default __webpack_public_path__ + "static/sustainability-1-d732360679df4b69005241a6e4680cb7.jpg";